import { BasicRequest } from "./basicRequest";

export class StartMoovInstanceRequest extends BasicRequest{
    public moovInstanceId!:number;

    constructor(){
        super();
    }
}